import React, { useMemo, useRef, useState } from "react";
import './profile.scss'
import { Form } from "devextreme-react";
import { GroupItem, Label, RequiredRule, SimpleItem } from "devextreme-react/form";
import BaseFormWithBreadCrumbs from "../../../components/base-form/base-form";
import { getPropsDateEdit } from "../../../utils/default-props";
import { useLookupGroup } from "../../../contexts/lookup-group-context";
import { useEffect } from "react";
import { useAuth } from "../../../contexts/auth";
import { lookupGroups } from "../../../utils/lookup-groups.ts";
import { useDataSource } from "../../../contexts/dataSource";


export default function WorkPlace({ employeeId }) {

    const [formData, setFormData] = useState({
        id: "",
        employeeId: "",
        positionInfoId: "",
        groupInfoId: "",
        startDate: "",
        endDate: "",
        contractTypeId: "",
        workEnvironmentId: "",        
        shiftId: "",
    })
    const [readOnly, setReadOnly] = useState(false)
    const [dirty, setDirty] = useState(false)
    const [contractTypeList, setContractTypeList] = useState()
    const [workEnvironmentList, setWorkEnvironmentList] = useState()
    
    const formRef = useRef()
    const { user } = useAuth()
    const { getLookupData } = useLookupGroup()
    const { activeLanguage } = useAuth()
    const { dataSourceHR } = useDataSource()

    const dbPosition = useMemo(() => dataSourceHR({
        loadUrl: "/api/PositionInfo"
    }), [])

    const contractTypeOption = {
        items: contractTypeList,
        valueExpr: "id",
        displayExpr: "text"
    }
    const workEnvironmenOption = {
        items: workEnvironmentList,
        valueExpr: "id",
        displayExpr: "text"
    }

    const positionInfoOptions = useMemo(()=>({
        dataSource: dbPosition,
        valueExpr: "id",
        displayExpr: "name"
    }),[])

    const handleFieldDataChanged = (e) => {
        setDirty(true)
    }

    useEffect(() => {
        getLookupData(lookupGroups.contractType).then(response => setContractTypeList(response))
        getLookupData(lookupGroups.workEnvironment).then(response => setWorkEnvironmentList(response))        
    }, [activeLanguage])
    return (
        <React.Fragment>
            <BaseFormWithBreadCrumbs
                formData={formData}
                setFormData={setFormData}
                formRef={formRef}
                readOnly={readOnly}
                setReadOnly={setReadOnly}
                dirty={dirty}
                setDirty={setDirty}
                initialValues={{ employeeId: employeeId }}
                loadId={employeeId}
                loadUrl={"/api/EmployeeWorkPlace/Employee/"}
                updateUrl={"/api/EmployeeWorkPlace/FormData"}
            >
                <Form
                    formData={formData}
                    ref={formRef}
                    readOnly={readOnly}
                    //colCountByScreen={colCountByScreen}
                    onFieldDataChanged={handleFieldDataChanged}
                    width={500}
                >
                    <GroupItem caption="İşyeri">

                        <SimpleItem dataField="positionInfoId" editorType="dxSelectBox" editorOptions={positionInfoOptions}>
                            <Label text="Pozisyon" />
                        </SimpleItem>
                        <SimpleItem dataField="startDate" {...getPropsDateEdit}>
                            <Label text="İşe Giriş Tarihi" />
                            <RequiredRule />
                        </SimpleItem>
                        <SimpleItem dataField="endDate" {...getPropsDateEdit}>
                            <Label text="İşten Ayrılış Tarihi" />
                        </SimpleItem>
                        <SimpleItem dataField="contractTypeId" editorType="dxSelectBox" editorOptions={contractTypeOption}>
                            <Label text="Sözleşme Türü" />
                        </SimpleItem>
                        <SimpleItem dataField="workEnvironmentId" editorType="dxSelectBox" editorOptions={workEnvironmenOption}>
                            <Label text="Çalışma Ortamı" />
                        </SimpleItem>
                        <SimpleItem dataField="shiftId">
                            <Label text="Vardiyası" />
                        </SimpleItem>
                        <SimpleItem dataField="groupInfoId">
                            <Label text="Grup" />
                        </SimpleItem>
                    </GroupItem>
                </Form>

            </BaseFormWithBreadCrumbs>

        </React.Fragment>
    )
}

const colCountByScreen = {
    xs: 1,
    sm: 2,
    md: 3,
    lg: 4
};